<div class="grid" *ngIf="globalSettinsData">
  <div class="col-2 mr-2">
    <app-currencyselector #cs1 labelKey="Валюта баланса" [selectedID]="globalSettinsData.balanceCurrencyId"
                          disabled="false" [showEditButton]="false" [showAddRateButton]="false" [showAddCurrencyButton]="false"
                          (SelectedCurrencyID)="getSelectedACurrency($event)"></app-currencyselector>
  </div>
  <div class="col-2 mr-2">
    <app-currencyselector #cs2 labelKey="Валюта для справки" [selectedID]="globalSettinsData.viewDCurrencyId"
                          disabled="false" [showEditButton]="false" [showAddRateButton]="false" [showAddCurrencyButton]="false"
                          (SelectedCurrencyID)="getSelectedBCurrency($event)"></app-currencyselector>
  </div>
  <div class="col-2 mr-2">
    <app-currencyselector #cs3 labelKey="Валюта для справки" [selectedID]="globalSettinsData.viewECurrencyId"
                          disabled="false" [showEditButton]="false" [showAddRateButton]="false" [showAddCurrencyButton]="false"
                          (SelectedCurrencyID)="getSelectedCCurrency($event)"></app-currencyselector>
  </div>
</div>
<div class="fluid grid flex ">
  <div class="p-flex-row col-12">
    <p-chart type="line" [data]="data" [options]="basicOptions" (onDataSelect)="selectData($event)" height="20rem"></p-chart>
  </div>
</div>
